import { useStopwatch } from 'react-timer-hook';
import moment from 'moment';

function StopWatch({
  startOffset
}: {
  startOffset: string
}) {

  const {
    seconds,
    minutes,
    hours,
    days
  } = useStopwatch({ autoStart: true, offsetTimestamp: getStartOffset() });

  function getStartOffset(): Date {
    const offset = moment.duration(moment().diff(moment(startOffset)));
    return moment().add(offset).toDate();
  }

  return (
    <div className="stop-watch mt-2">
      <NumberDisplay label='Days' numberToDisplay={days}/>
      <Separator/>
      <NumberDisplay label='Hours' numberToDisplay={hours}/>
      <Separator/>
      <NumberDisplay label='Minutes' numberToDisplay={minutes}/>
      <Separator/>
      <NumberDisplay label='Seconds' numberToDisplay={seconds}/>
    </div>
  );
}

function NumberDisplay({
  label,
  numberToDisplay
}: {
  label: string,
  numberToDisplay: number
}) {

  let firstDigit = Math.floor(numberToDisplay / 10);
  let secondDigit = numberToDisplay % 10;

  return (
    <div className="stop-watch-number-display">
      <span className="stop-watch-number-display-label">{label.toLocaleUpperCase()}</span>
      <div>
        <span className="stop-watch-number-display-digit">{firstDigit}</span>
        <span className="stop-watch-number-display-digit">{secondDigit}</span>
      </div>
    </div>
  );
}

function Separator() {
  return (
    <span className="stop-watch-separator">
      <span/>
      <span/>
    </span>
  );
}

export default StopWatch;
